const projects = [
  {
    title: 'VillasCop',
    image: '/projects/villascop.png',
    description: 'High-performance real estate landing page built with Next.js — smooth animations, conversion-optimized layout, and a premium property showcase experience.',
    technologies: ['Next.js', 'React', 'Tailwind CSS'],
    live: 'https://www.landing-villascop.fr/',
    github: 'https://github.com/am11iin?tab=repositories&q=VillasCop'
  },
  {
    title: 'Aissawi Dates',
    image: '/projects/aissa-widates.png',
    description: 'Bilingual product showcase for a premium Algerian dates brand — clean product catalog, responsive layout, and seamless English / Arabic navigation experience.',
    technologies: ['Next.js', 'React', 'Multilingual', 'TypeScript'],
    live: 'https://aissawidates.com/en/',
    github: 'https://github.com/am11iin/aissawidates-web'
  },
  {
    title: 'MT Gaming',
    image: '/projects/mt-gaming.jpg',
    description: 'Bilingual (FR/AR) website for a premium gaming center in Alger — showcasing PS5, PS4 and Xbox 360 consoles, game catalog, pricing, and gallery. Features dark/light theme toggle.',
    technologies: ['HTML', 'CSS', 'JavaScript', 'Bilingual'],
    live: 'https://mt-gaming-website.vercel.app/',
    github: 'https://github.com/am11iin/mt-gaming-website'
  },
  {
    title: 'Mesdjed Ar-Rahma',
    image: '/projects/masjid-arrahma.jpg',
    description: 'Bilingual mosque website (AR/FR) for Mesdjed Ar-Rahma in Bouchaoui, Algeria — real-time prayer times with Hijri calendar, RTL layout, Ramadan section, and events.',
    technologies: ['HTML', 'CSS', 'JavaScript', 'RTL', 'Bilingual'],
    live: 'https://masjid-arrahma-website-jcs9.vercel.app/',
    github: 'https://github.com/am11iin/masjid-arrahma-website'
  },
  {
    title: 'TAKWINI 2.0',
    image: '/projects/takwini.jpg',
    description: 'Corporate Learning Management System for Gulf Insurance Group (GIG) Algeria — full-stack LMS with FastAPI backend, React frontend, PostgreSQL, Redis caching, JWT auth, and role-based access control.',
    technologies: ['React', 'TypeScript', 'FastAPI', 'PostgreSQL', 'Redis'],
    live: null,
    github: 'https://github.com/am11iin/TAKWINI-2.0'
  },
  {
    title: 'Cercle Menuiserie',
    image: '/projects/cercle-menuiserie.png',
    description: 'Professional corporate website for a French carpentry company — polished brand identity, service showcase, and a credibility-driven design with strong SEO foundations.',
    technologies: ['React', 'Responsive Design', 'SEO', 'UI/UX'],
    live: 'https://www.cerclemenuiserie.com/',
    github: 'https://github.com/am11iin?tab=repositories&q=Cercle+Menuiserie'
  },
  {
    title: 'Hiking Journal',
    image: '/projects/hiking-journal.png',
    description: 'Interactive hiking journal built with React & Framer Motion — animated route cards, destination gallery, and fluid page transitions for an immersive outdoor experience.',
    technologies: ['React', 'Vite', 'Tailwind CSS', 'Framer Motion'],
    live: 'https://amine-hiking-journal.netlify.app/',
    github: 'https://github.com/am11iin/amine-hiking-journal'
  }
];

export default projects;
